import React from 'react';
import path from 'path';
import Helmet from 'react-helmet';
import config from '../config';
import ogImage from '../static/images/og-cover.png';

const SEO = ({ siteData, siteImage, isSEO, type }) => {
  const title = siteData.title || config.title;
  const description = siteData.description || config.description;
  const image = `${config.url}${ogImage}` || config.image;
  const url = siteData.slug ? `${config.url}${siteData.slug}` : config.url;
  const position = siteData.position ? siteData.position : 0;

  return (
    <Helmet>
      {/* General tags */}
      <title>
        {title}
        {config.title}
      </title>
      <meta name="description" content={description} />
      <meta name="image" content={image} />

      {/* OpenGraph tags */}
      <meta property="og:url" content={url} />
      {isSEO ? <meta property="og:type" content="article" /> : null}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
    </Helmet>
  );
};

SEO.defaultProps = {
  isSEO: false,
  postImage: null,
  siteData: {},
};

export default SEO;



// WEBPACK FOOTER //
// ./src/components/SEO.js